import React, { useState } from 'react';

import { Link } from 'react-router-dom'

import bg from '../assets/images/hero/bg.png'

import ModalVideo from 'react-modal-video';

import { FiVideo } from 'react-icons/fi'
import AboutTwo from './about-two'

export default function HomeBanner() {
    let [isOpen, setOpen] = useState(false);
  return (
    <section className="bg-half-170 d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'bottom', backgroundRepeat:'no-repeat'}} id='home'>
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-7 col-md-6">
                    <div className="title-heading">
                        <ul className="list-unstyled mb-0 h5 text-warning">
                            <li className="list-inline-item me-1"><span className="badge bg-white shadow text-dark fw-bold">Rating 4.5 of 5</span></li>
                            <li className="list-inline-item"><i className="mdi mdi-star"></i></li>
                            <li className="list-inline-item"><i className="mdi mdi-star"></i></li>
                            <li className="list-inline-item"><i className="mdi mdi-star"></i></li>
                            <li className="list-inline-item"><i className="mdi mdi-star"></i></li>
                            <li className="list-inline-item"><i className="mdi mdi-star-half-full"></i></li>
                        </ul>
                        <h1 className="heading my-3">Build a Anything <br/>Consulting Business.</h1>
                        <p className="para-desc text-muted">We've cultivated a dynamic space where creativity seamlessly intertwines with strategy and innovation.</p>
                        <div className="mt-4 pt-2">
                            <Link to="/services" className="btn btn-primary m-1">Our Services</Link>
                            <Link to="#!" onClick={() => setOpen(true)} className="btn btn-icon btn-pills btn-primary m-1 lightbox"><FiVideo className="icons"/></Link><span className="fw-bold text-uppercase small align-middle ms-2">Watch Now</span>
                        </div>
                    </div>
                    <ModalVideo
                        channel="youtube"
                        youtube={{ mute: 0, autoplay: 0 }}
                        isOpen={isOpen}
                        videoId="yba7hPeTSjk"
                        onClose={() => setOpen(false)} 
                    />
                </div>

                <div className="col-lg-5 col-md-6">
                    <AboutTwo/>
                </div>
            </div>
        </div>
    </section>
  )
}
